/** Spanish message catalogue (manual until Lingui macro extraction). */
export const messages = {
  "common.home": "Inicio",
  "common.docs": "Documentos",
  "common.search": "Buscar",
  "common.chat": "Chat",
  "common.notebooks": "Mis apuntes",
  "common.upload": "Importar",
  "common.settings": "Ajustes",
  "common.create": "Crear",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Eliminar",
  "common.close": "Cerrar",
  "common.confirm": "Confirmar",
  "common.loading": "Cargando…",
  "common.error": "Algo no salió bien",
  "common.retry": "Reintentar",
  "common.search_placeholder": "Buscar docs, secciones, acciones…",
  "common.empty": "No hay datos",
  "shell.scope.project": "Proyecto",
  "shell.scope.all": "Todos",
  "shell.theme.light": "Modo claro",
  "shell.theme.dark": "Modo oscuro",
  "shell.theme.system": "Sistema",
  "shell.toggle_sidebar": "Alternar barra lateral",
  "shell.toggle_ai": "Alternar panel IA",
  "shell.toggle_chat": "Alternar chat",
  "shell.notifications": "Notificaciones",
  "docs.title": "Documentos",
  "docs.empty": "Aún no hay documentos. Importa el primero.",
  "search.placeholder": "Pregunta cualquier cosa sobre tu documentación",
  "search.empty": "No encontramos resultados. Prueba sin filtros.",
  "chat.welcome": "Empieza una conversación",
  "chat.input_placeholder": "Tu pregunta… ⌘↵ enviar",
  "notebook.add_item": "Añadir item",
  "notebook.empty": "Este notebook está vacío",
  "upload.dropzone": "Arrastra archivos aquí o haz clic",
  "upload.accepts": "Acepta .md .docx .pdf .html .csv .xlsx (max 50MB)",
} as const;
export type MessageKey = keyof typeof messages;
